import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [{
    path: '/orderSettlement',
    name: 'OrderSettlement',
    component: () => import('@/pages/orderSettlement/orderSettlement')
  },
  {
    path: '/aliPay',
    name: 'aliPay',
    component: () => import('@/pages/orderSettlement/aliPay')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/pages/loginManager/login')
  },
  {
    path: '/orderList',
    name: 'orderList',
    meta: {
      isLogin: true
    },
    component: () => import('@/pages/orderList/orderList')
  },
  {
    path: '/address/AddressList',
    name: 'AddressList',
    meta: {
      isLogin: true
    },
    component: () => import('@/pages/address/AddressList')
  },
  {
    path: '/address/AddressInfo',
    name: 'AddressInfo',
    meta: {
      isLogin: true
    },
    component: () => import('@/pages/address/AddressInfo')
  },
  {
    path: '/productDetail',
    name: 'ProductDetail',
    component: () => import('@/pages/productDetail/productDetail')
  },
  {
    path: '/orderDetail',
    name: 'orderDetail',
    meta: {
      isLogin: true
    },
    component: () => import('@/pages/orderDetail/orderDetail')
  },
  {
    path: '/couponList',
    name: 'couponList',
    meta: {
      isLogin: true
    },
    component: () => import('@/pages/coupon/couponList')
  },
      {
          path: '/userCouponList',
          name: 'userCouponList',
          meta: {
              isLogin: true
          },
          component: () => import('@/pages/userCoupon/userCouponList')
      },
  {
    path: '/logistics',
    name: 'logistics',
    meta: {
      isLogin: true
    },
    component: () => import('@/pages/logistics/logistics')
  },
  {    //测试唤醒app
    path: '/getApp',
    name: 'getApp',
    component: () => import('@/common/getApp/t')
  },
  {    //测试唤醒app
    path: '/download',
    name: 'download',
    component: () => import('@/pages/download/download')
  },
  {
    path: '/orderFinish',
    name: 'orderFinish',
    meta: {
      isLogin: true
    },
    component: () => import('@/pages/orderFinish/orderFinish')
  },
  {
    path: '/vip',
    name: 'vip',
    meta: {
      isLogin: true
    },
    component: () => import('@/pages/vipPage/vipPage')
  },
  {
    path: '/memberCard',
    name: 'memberCard',
    meta: {
      isLogin: true
    },
    component: () => import('@/pages/memberCard/memberCard')
  },
  {
    path: '/userInfo',
    name: 'userInfo',
    meta: {
      isLogin: true
    },
    component: () => import('@/pages/userInfo/userInfo')
  },
  {
    path: '/userInfo/setting',
    name: 'userInfoSetting',
    meta: {
      isLogin: true
    },
    component: () => import('@/pages/userInfo/setting')
  },
  {
    path: '/userInfo/balancePayment',
    name: 'balancePayment',
    meta: {
      isLogin: true
    },
    component: () => import('@/pages/userInfo/balancePayment')
  },
  {
    path: '/materialDetail',
    name: 'materialDetail',
    component: () => import('@/pages/materialDetail/materialDetail')
  },
  {
    path: '/permanentMembers',
    name: 'permanentMembers',
    component: () => import('@/pages/permanentMembers/permanentMembers')
  },
  {
    path: '/newMaterialDetail',
    name: 'newMaterialDetail',
    component: () => import('@/pages/materialDetail/materialDetail')
  },
  {
    path: '/test',
    name: 'test',
    component: () => import('@/pages/test/test')
  },
  {
    path: '/cart',
    name: 'cart',
    meta: {
      isLogin: true
    },
    component: () => import('@/pages/shoppingCart/shoppingCart')
  },
  {
    path: '/bindInvitor',
    name: 'bindInvitor',
    meta: {
      isLogin: true
    },
    component: () => import('@/pages/bindInvitor/bindInvitor')
  },
  {
    path: '/paymentCenter',
    name: 'paymentCenter',
    meta: {
      isLogin: true
    },
    component: () => import('@/pages/paymentCenter/paymentCenter')
  },{
    path: '/customServiceLanding',
    name: 'customServiceLanding',
    meta: {
      isLogin: true
    },
    component: () => import('@/pages/customServiceLanding/customServiceLanding')
  },{
    path: '/vipGiftBagHome',
    name: 'vipGiftBagHome',
    meta: {
      isLogin: true
    },
    component: () => import('@/pages/vipGiftBagHome/vipGiftBagHome')
  },{
    path: '/thanksGivingLastPage',
    name: 'thanksGivingLastPage',
    meta: {
      isLogin: true
    },
    component: () => import('@/pages/thanksGivingLastPage/thanksGivingLastPage')
  },{
    path: '/learnToBeBetterExplain',
    name: 'learnToBeBetterExplain',
    meta: {
      isLogin: false
    },
    component: () => import('@/pages/learnToBeBetterExplain/learnToBeBetterExplain')
  },{
    path: '/productList',
    name: 'productList',
    meta: {
        isLogin: true
    },
    component: () => import('@/pages/productList/productList')
  },{
      path: '/activePage',
      name: 'activePage',
      meta: {
          isLogin: false
      },
      component: () => import('@/pages/activePage/activePage')
  }],
  /**
   *如果通过浏览器自带的前进后退按钮切换的路由，那么会自动使用浏览默认的回滚上次页面的浏览位置。
   *如果是通过vue路由进行的页面切换。例如a前往b，首先判断a是不是通过keep-alive缓存的组件，如果是，
   *则在a路由的meta中添加一个savedPosition字段，并且值为a的滚动位置。最后return的是页面需要回滚的位置。
   *如此一来，如果打开一个页面，该页面的组件路由中meta.savedPosition为undefined的话，则页面滚动到（0,0）的位置，
   *如果打开一个页面，它的路由的meta.savedPosition有值的话，则滚动到上次浏览的位置，
   *因为meta.savedPosition保存的就是上次浏览的位置。
   */
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition
    } else {
      if (from.meta.keepAlive) {
        from.meta.savedPosition = document.body.scrollTop
      }
      return {
        x: 0,
        y: to.meta.savedPosition || 0
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js